// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
// Components, Layouts, Pages
import {
  HeaderStatisticComponent,
  ScheduleTodayComponent,
  TaskTodayComponent,
} from '~/components/module/dashboard';
// Others
// Styles, images, icons
import styles from './Dashboard.module.scss';

const cx = classNames.bind(styles);

const Dashboard = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='dashboardPage' className={cx('container')}>
      <HeaderStatisticComponent />

      <Box component={'div'} className={cx('body')}>
        <TaskTodayComponent />

        <ScheduleTodayComponent />
      </Box>
    </Box>
  );
};

export default Dashboard;
